export const productsInitialState = [
  {
    id: 'PRD-001',
    name: 'Motor Insurance',
    category: 'Vehicle',
    description:
      'Comprehensive coverage for your vehicle including third party, theft, and accident damage.',
    icon: '🚗',
    status: 'active',
    popularity: 95,
    activePolicies: 1247,
    basePrice: 500000,
    coverageFrom: 5000000,
    coverageTo: 50000000,
    features: [
      'Third Party Cover',
      'Theft Protection',
      'Accident Damage',
      'Windscreen Cover',
      'Towing Services',
    ],
    exclusions: ['Racing', 'Drunk Driving', 'Unauthorized Use'],
    tags: ['Popular', 'Comprehensive'],
  },
  {
    id: 'PRD-002',
    name: 'Fire Insurance',
    category: 'Property',
    description:
      'Protection against fire damage to buildings, contents, and stock with optional perils.',
    icon: '🔥',
    status: 'active',
    popularity: 88,
    activePolicies: 892,
    basePrice: 800000,
    coverageFrom: 10000000,
    coverageTo: 100000000,
    features: ['Fire Damage', 'Lightning', 'Explosion', 'Smoke Damage', 'Fire Brigade Charges'],
    exclusions: ['War', 'Nuclear Risks', 'Willful Acts'],
    tags: ['Essential', 'Property'],
  },
  {
    id: 'PRD-003',
    name: 'Flood Insurance',
    category: 'Property',
    description:
      'Coverage for flood-related damages to property, contents, and business interruption.',
    icon: '🌊',
    status: 'active',
    popularity: 72,
    activePolicies: 534,
    basePrice: 600000,
    coverageFrom: 8000000,
    coverageTo: 80000000,
    features: [
      'Flood Damage',
      'Water Damage',
      'Basement Coverage',
      'Temporary Housing',
      'Contents Protection',
    ],
    exclusions: ['Coastal Erosion', 'Underground Water', 'Gradual Damage'],
    tags: ['Seasonal', 'Weather'],
  },
  {
    id: 'PRD-004',
    name: 'Home Insurance',
    category: 'Property',
    description:
      'Complete protection for your home including structure, contents, and liability coverage.',
    icon: '🏠',
    status: 'active',
    popularity: 91,
    activePolicies: 1089,
    basePrice: 450000,
    coverageFrom: 15000000,
    coverageTo: 150000000,
    features: [
      'Building Cover',
      'Contents Insurance',
      'Personal Liability',
      'Alternative Accommodation',
      'Garden Cover',
    ],
    exclusions: ['Wear and Tear', 'Maintenance Issues', 'Intentional Damage'],
    tags: ['Popular', 'Comprehensive', 'Family'],
  },
  {
    id: 'PRD-005',
    name: 'Marine Insurance',
    category: 'Transport',
    description: 'Cargo and hull insurance for marine transportation with worldwide coverage.',
    icon: '⚓',
    status: 'active',
    popularity: 68,
    activePolicies: 421,
    basePrice: 1200000,
    coverageFrom: 20000000,
    coverageTo: 200000000,
    features: [
      'Cargo Protection',
      'Hull Damage',
      'Port Coverage',
      'Transit Insurance',
      'Salvage Costs',
    ],
    exclusions: ['War Risks', 'Inherent Vice', 'Improper Packing'],
    tags: ['Commercial', 'International'],
  },
  {
    id: 'PRD-006',
    name: 'Health Insurance',
    category: 'Personal',
    description:
      'Medical coverage including hospitalization, outpatient, and specialist consultations.',
    icon: '⚕️',
    status: 'active',
    popularity: 93,
    activePolicies: 1521,
    basePrice: 350000,
    coverageFrom: 5000000,
    coverageTo: 50000000,
    features: [
      'Hospitalization',
      'Outpatient Care',
      'Specialist Visits',
      'Prescription Drugs',
      'Emergency Services',
    ],
    exclusions: ['Pre-existing Conditions', 'Cosmetic Surgery', 'Experimental Treatments'],
    tags: ['Popular', 'Essential', 'Family'],
  },
  {
    id: 'PRD-007',
    name: 'Life Insurance',
    category: 'Personal',
    description:
      'Financial protection for your loved ones with death benefit and investment options.',
    icon: '💝',
    status: 'active',
    popularity: 85,
    activePolicies: 967,
    basePrice: 250000,
    coverageFrom: 10000000,
    coverageTo: 500000000,
    features: [
      'Death Benefit',
      'Terminal Illness Cover',
      'Investment Component',
      'Premium Waiver',
      'Flexible Terms',
    ],
    exclusions: ['Suicide (first 2 years)', 'War', 'Criminal Activity'],
    tags: ['Long-term', 'Investment'],
  },
  {
    id: 'PRD-008',
    name: 'Travel Insurance',
    category: 'Personal',
    description:
      'Coverage for medical emergencies, trip cancellation, and baggage loss while traveling.',
    icon: '✈️',
    status: 'active',
    popularity: 79,
    activePolicies: 645,
    basePrice: 150000,
    coverageFrom: 2000000,
    coverageTo: 20000000,
    features: [
      'Medical Emergency',
      'Trip Cancellation',
      'Baggage Loss',
      'Flight Delay',
      'Personal Liability',
    ],
    exclusions: ['Pre-existing Medical', 'High-risk Activities', 'Unattended Baggage'],
    tags: ['Short-term', 'International'],
  },
  {
    id: 'PRD-009',
    name: 'Business Insurance',
    category: 'Commercial',
    description: 'Comprehensive coverage for business operations, property, and liability.',
    icon: '🏢',
    status: 'active',
    popularity: 76,
    activePolicies: 523,
    basePrice: 1500000,
    coverageFrom: 30000000,
    coverageTo: 300000000,
    features: [
      'Property Damage',
      'Business Interruption',
      'Public Liability',
      'Employer Liability',
      'Equipment Cover',
    ],
    exclusions: ['Professional Negligence', 'Cyber Risks', 'Pollution'],
    tags: ['Commercial', 'Comprehensive'],
  },
  {
    id: 'PRD-010',
    name: 'Cyber Insurance',
    category: 'Commercial',
    description:
      'Protection against cyber attacks, data breaches, and digital business interruption.',
    icon: '🔒',
    status: 'new',
    popularity: 61,
    activePolicies: 178,
    basePrice: 900000,
    coverageFrom: 10000000,
    coverageTo: 100000000,
    features: [
      'Data Breach',
      'Cyber Attack',
      'Business Interruption',
      'Legal Costs',
      'Notification Expenses',
    ],
    exclusions: ['Intentional Acts', 'Known Vulnerabilities', 'Unencrypted Data'],
    tags: ['New', 'Technology', 'Growing'],
  },
  {
    id: 'PRD-011',
    name: 'Professional Indemnity',
    category: 'Commercial',
    description:
      'Liability coverage for professionals against claims of negligence or breach of duty.',
    icon: '👔',
    status: 'active',
    popularity: 70,
    activePolicies: 412,
    basePrice: 700000,
    coverageFrom: 15000000,
    coverageTo: 150000000,
    features: [
      'Professional Negligence',
      'Legal Defense',
      'Court Costs',
      'Compensation Claims',
      'Breach of Duty',
    ],
    exclusions: ['Criminal Acts', 'Fraud', 'Libel and Slander'],
    tags: ['Professional', 'Liability'],
  },
  {
    id: 'PRD-012',
    name: 'Agriculture Insurance',
    category: 'Specialized',
    description: 'Coverage for crops, livestock, and farming equipment against various perils.',
    icon: '🌾',
    status: 'active',
    popularity: 64,
    activePolicies: 289,
    basePrice: 550000,
    coverageFrom: 5000000,
    coverageTo: 50000000,
    features: [
      'Crop Loss',
      'Livestock Death',
      'Equipment Damage',
      'Weather Protection',
      'Pest Damage',
    ],
    exclusions: ['Negligence', 'Market Price Fluctuations', 'Natural Degradation'],
    tags: ['Specialized', 'Rural'],
  },
];
